import { Button } from '@/components/ui/button';
import { CreditCard, Sparkles } from 'lucide-react';
import { useContext } from 'react';
import UserContext from '../UserContext';

interface LimitReachedMessageProps {
  onUpgradeClick: () => void;
}

export default function LimitReachedMessage({ onUpgradeClick }: LimitReachedMessageProps) {
  const  { userDetails } = useContext(UserContext);
  return (
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-6 mb-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-amber-900 dark:text-amber-400 font-semibold text-base mb-2">
            Credit Limit Reached
          </h3>
          <p className="text-amber-800 dark:text-amber-300 text-sm mb-4">
            You've used all your available credits.{' '}
            {userDetails?.subscription_type === 'free' || !userDetails?.subscription_id
              ? 'Upgrade your plan'
              : 'Upgrade your plan or purchase more credits'}{' '}
            to continue creating images.
          </p>
          <div className="flex gap-3">
            <Button
              onClick={onUpgradeClick}
              className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white"
              size="sm"
            >
              Upgrade Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}